<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <CRow >
              <CCol >
              <label> Tilte </label>
              <b-input v-model="form.title" placeholder='Title' :state="validationTitle" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback :state="validationTitle">
              Your title must be filled
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationTitle">
              Looks Good.
              </b-form-valid-feedback>  
              </CCol>
            </CRow>
             <CRow class="mt-3">
              <CCol >
                <label> URL </label>
              <b-input v-model="form.url" placeholder='www.example.com' :state="validationURL" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback :state="validationURL">
              Your URL must be filled
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationURL">
              Looks Good.
              </b-form-valid-feedback>  
              </CCol>
            </CRow>
             <CRow class="mt-3">
              <CCol >
                <label> Author </label>
              <b-input v-model="form.author" placeholder='Author' :state="validationAuthor" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback :state="validationAuthor">
              Your author must be filled
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationAuthor">
              Looks Good.
              </b-form-valid-feedback>  
              </CCol>
            </CRow>
            
            <CRow class="mt-3" >
              <CCol >
              <label> Description </label>
              <c-textarea v-model="form.description" placeholder='Description'  rows="10"   class="mb-1"> </c-textarea>
              
              </CCol>
            </CRow>

             <CRow class="mt-3">
              <CCol >
              <div>
                <label> Image </label>
              </div>
              <b-form-file
                v-if="mode === 'create'"
                v-model="form.image"
                plain
              ></b-form-file>
              <img
                v-bind:src="getPhoto(form.get_photo)"
                width="450"
                height="200"
              />
              <CButton
                class="ml-3"
                v-if="mode === 'edit'"
                type="button"
                @click="openModalPhotoImage(form.id)"
                variant="outline"
                color="info"
                >Change Image</CButton
              >
              </CCol>
            </CRow>

            
            <CRow class="mt-3">
              <CCol >
               <label> Department </label>
                 <b-form-select
                v-model="form.department"
                :options="options_department"
                >
              </b-form-select>
              
              </CCol>
            </CRow>
             <CRow class="mt-3">
              <CCol >
               <label> Category Sermon </label>
                 <!-- <b-form-select
                v-model="form.category_sermon"
                :options="options_sermont"
                >
              </b-form-select> -->
              
              <multiselect v-model="form.category_sermon" placeholder="" :custom-label="a" :options="options_sermont" label="text" track-by="value" :multiple="true"></multiselect>

              </CCol>
            </CRow>
             <CRow class="mt-3">
              <CCol >
               <label> Section </label>

               
                 <b-form-select
                v-model="form.section"
                :options="options_section"
                >
              </b-form-select>
              
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol >
              
                <!-- <b-form-checkbox 
              class="mt-3"
              id="checkbox-1"
              v-model="form.spotlight"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
            >
              Berikan tanda <b-icon icon="check" font-scale="1.5"> ></b-icon>  untuk <b>Menyoroti</b> link content ini.
            </b-form-checkbox> -->
              
              </CCol>
            </CRow>

            
            
          </CCol> 
          </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Update</CButton>
      </template>
    </CModal>
    <modalphotobg></modalphotobg>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import axios from 'axios'

import linkcontent from '@/services/linkcontent'
import section from '@/services/section'
import department from '@/services/department'
import sermon from '@/services/categorysermon'
import modalphotobg from "./modal_photo_bgimage.vue";

import Multiselect from 'vue-multiselect'


export default {
name: 'sectionmodal',
components: {Multiselect,modalphotobg   },
  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id: '',
        title: '',
        url:'',
        author:'',
        description:'',
        image:'',
        department:'',
        category_sermon:'',
        section:'',
        spotlight:'0',
        get_photo:'',
      },
      options_department:[],
      options_section:[],
      options_sermont:[],
   
      
    }
  },
   computed: {
      validationTitle() {
        return this.form.title.length > 0 
      },
      validationURL() {
        return this.form.url.length > 0 
      },
      validationAuthor() {
        return this.form.author.length > 0 
      },
   },
  mounted(){
    
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_LINK', (params) => {
      if(params.data){
        linkcontent.getLinkContentbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = params.data;
          self.form.title = res.data.title;
          self.form.url = res.data.url;
          self.form.author = res.data.author;
          self.form.description = res.data.description;
          self.form.image = res.data.image;
          self.form.department = res.data.department.id;
          //self.form.category_sermon = res.data.category_sermon.id;
          self.form.category_sermon = JSON.parse(res.data.category_sermon);
          self.form.section = res.data.section.id;
          self.form.spotlight = res.data.spotlight;
          self.form.get_photo = res.data.get_photo;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.title = "";
        self.form.url = "";
        self.form.author = "";
        self.form.description = "";
        self.form.image = "";
        self.form.department = "";
        self.form.category_sermon = "";
        self.form.section = "";
        self.form.spotlight = "0";
      }
    });
    department.getDepartment()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_department.push({text:res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
        
      }),
       section.getSection()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_section.push({text:res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
        
      }),
       sermon.getCategorySermon()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_sermont.push({text:res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
        
      })
  },

  

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    getPhoto(data){
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    }, 
    create(){
      let formData = new FormData();
      formData.append('image', this.form.image );
      formData.append('description', this.form.description ? this.form.description : '' );  //fix bug if description empty send "null"
      formData.append('department', this.form.department );
      formData.append('title', this.form.title );
      formData.append('section', this.form.section );
      formData.append('spotlight', this.form.spotlight );
      formData.append('author', this.form.author );
      formData.append('url', this.form.url );

      formData.append('category_sermon', JSON.stringify(this.form.category_sermon) );
      if(Boolean(this.form.department)){
        linkcontent.createLinkContent(formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      }else{
        var params = {title: 'Error', mode:'danger', data:'department harus di isi'}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }
     
    },
    update(id){
      let formData = new FormData();
      formData.append('image', this.form.image );
      formData.append('description', this.form.description ? this.form.description : ''  ); //fix bug if description empty send "null"
      formData.append('department', this.form.department );
      formData.append('title', this.form.title );
      formData.append('section', this.form.section );
      formData.append('spotlight', this.form.spotlight );
      formData.append('author', this.form.author );
      formData.append('url', this.form.url );
      formData.append('category_sermon', JSON.stringify(this.form.category_sermon) );

      this.show = false;
      //linkcontent.updateLinkContent(id, this.form)
      linkcontent.updateLinkContent(id, formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    
    openModalPhotoImage(id) {
      var params = { title: "Update BG Image", mode: "edit", data: id };
      EventBus.$emit("OPEN_MODAL_EVENT_PHOTO_BGIMAGE_LINKCONTENT", params);
      console.log("load modal photo");
     },
     
    getPhoto(data){

        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    }, 
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>